import axios from "axios";
import { VueAxios } from "./axios";
import sign from "@/utils/sign";
import { getSignKey } from "@/utils/base";
const BASEURL = process.env.VUE_APP_BASE_API;

// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: process.env.VUE_APP_BASE_API,
  // withCredentials: true,  //允许跨域拿证书
  timeout: 6000, // 请求超时时间
});

// 异常拦截处理器
const errorHandler = (error) => {
  return Promise.reject(error);
};

// request interceptor
request.interceptors.request.use((config) => {
  const signKey = getSignKey(config.url);
  const ts = Math.round(new Date() / 1000).toString();
  if (!config.url.includes(`${BASEURL}/api/reporting-data`)) {
    if (config.data instanceof FormData) {
      config.data.set("ts", ts);
      const formDataObj = Object.fromEntries(config.data.entries());
      config.data.set("sign", sign(formDataObj, signKey));
    } else {
      config.data.ts = ts;
      config.data.sign = sign(config.data, signKey);
    }
  }
  return config;
}, errorHandler);

// response interceptor
request.interceptors.response.use((response) => {
  return response.data;
}, errorHandler);

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, request);
  },
};

export default request;

export { installer as VueAxios, request as axios };
